import { render, staticRenderFns } from "./FInput.vue?vue&type=template&id=84b0f85c&scoped=true"
import script from "./FInput.vue?vue&type=script&lang=ts"
export * from "./FInput.vue?vue&type=script&lang=ts"
import style0 from "./FInput.vue?vue&type=style&index=0&id=84b0f85c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b0f85c",
  null
  
)

export default component.exports